import { app } from '../../../../../../app';
import { resolve } from '../../../../../../init/store';

app.service('SharedFolderAddNoteModal', modal);

/** @ngInject */
function modal($uibModal) {
    return (sharedFolder, items) => {
        return $uibModal.open({
            component: 'companySharingCenterSharedFoldersAddNote',
            resolve: {
                sharedFolder: () => sharedFolder,
                items: () => items,
                notes
            },
        }).result;

        /** @ngInject */
        function notes(SharedAccountsService) {
            let ids = getNoteIds();
            return SharedAccountsService
                .getAllCompanyNotes({companyId: resolve.companyId}).$promise
                .then(notes => notes.filter(note => {
                    let alreadyAdded = ids.includes(note.id);
                    return !alreadyAdded;
                }));
        }

        function getNoteIds() {
            let ids = [];
            items.forEach((item) => {
                if(item.corporateNote != null) {
                    ids.push(item.corporateNote.id);
                }
            });
            return ids;
        }
    };
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/add-note/shared-folder-add-note.modal.js